/* apps/viewer/src/app/not-found/not-found.component.scss */
:host {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
}
:host img {
  width: 30%;
}
/*# sourceMappingURL=not-found.component.css.map */
